import { render, staticRenderFns } from "./SelectApproversModal.vue?vue&type=template&id=55f55158&scoped=true&"
import script from "./SelectApproversModal.vue?vue&type=script&lang=js&"
export * from "./SelectApproversModal.vue?vue&type=script&lang=js&"
import style0 from "./SelectApproversModal.vue?vue&type=style&index=0&id=55f55158&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55f55158",
  null
  
)

export default component.exports